/*************************************************
    Button scroll to top
*************************************************/

document.addEventListener("DOMContentLoaded", () => {
  function trackScroll() {
    var scrolled = window.pageYOffset;
    var coords = document.documentElement.clientHeight;

    if (scrolled > coords) {
      goTopBtn.classList.add('show');
    }
    if (scrolled < coords) {
      goTopBtn.classList.remove('show');
    }
  }

  function backToTop() {
    $("html, body").animate({
      scrollTop: 0
    }, 1000);
  }

  var goTopBtn = document.querySelector('.scroll-to-top');

  window.addEventListener('scroll', trackScroll);
  goTopBtn.addEventListener('click', backToTop);
});


